export default __webpack_public_path__ + "static/media/react_animation.219ec364.png";